import { ToastIntent } from "@fluentui/react-components";
import { IDataContext } from "./IDataContext";
import { IUser } from "./IUser";

export interface IAuthContext {
  user?: IUser;
  isAuthenticated?: boolean;
  login: (request: IAuthRequest, dataContext: IDataContext) => Promise<void>;
  resetPassword: (
    request: IAuthRequest,
    dataContext: IDataContext
  ) => Promise<void>;
  logout: (
    dataContext: IDataContext,
    intent?: ToastIntent,
    msg?: string
  ) => void;
  validateToken?: (token: string) => Promise<boolean>;
}

export const initialAuthContext: IAuthContext = {
  user: undefined,
  login: undefined,
  logout: undefined,
  resetPassword: undefined,
  validateToken: undefined,
};

export interface IAuthRequest {
  id?: number;
  username: string;
  password: string;
}

export interface IPasswordrequest {
  password: string;
  confirmedPassword: string;
}
